import React from "react";
import './ComicPageView.scss';

interface ComicPageViewProps {
    webImageSrc: string,
    loading: boolean,
    onLoad: () => void,
    onClick: () => void
}

const ComicPageView = (props: ComicPageViewProps) => {

    return (
        <div className="comic-page-view">
            <div className="spinner-view" hidden={!props.loading}>
                <img src="/comic/spinner.gif" alt="Loading..."/>
            </div>
            <div className="comic-view">
                <a onClick={props.onClick}>
                    <img src={props.webImageSrc}
                         alt="Current page"
                         title="Click to open the full page!"
                         loading="eager"
                         onLoad={props.onLoad}/>
                </a>
            </div>
        </div>
    );
}

export default ComicPageView;